module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showResult),
      expression: "!showResult"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "diagnosis-process-wrapper",
    attrs: {
      "id": "buttons-tab"
    }
  }, [_c('ul', {
    staticClass: "btn-tabs clearfix gutter-10"
  }, _vm._l((_vm.tabs), function(tab, tabIndex) {
    return _c('li', {
      class: ("btn-tab f-gutter-8__li " + (tabIndex === 0 ? 'active' : '')),
      attrs: {
        "id": ("tabListId" + tabIndex)
      }
    }, [_c('button', {
      staticClass: "btn-tab__link",
      on: {
        "click": function($event) {
          return _vm.tabClick(tab.num, tab.num)
        }
      }
    }, [_vm._v("자가진단-" + _vm._s(tab.name))])])
  }), 0)]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.stepTitleNo == 0 ? '재무' : _vm.stepTitleNo == 1 ? '건강' : _vm.stepTitleNo == 2 ? '가족' : _vm.stepTitleNo == 3 ? '사회적 관계' : _vm.stepTitleNo == 4 ? '여가' : _vm.stepTitleNo == 5 ? '일과 자기계발' : _vm.stepTitleNo == 6 ? '사회공헌' : '결과') + " 설문입력")]), _vm._v(" "), _c('div', {
    staticClass: "btn-tab-content tab-content"
  }, [_vm._l((_vm.tabs), function(tab, tabIndex) {
    return _c('div', {
      class: ("btn-tab-pane tab-pane " + (tab.num == 0 ? 'active' : '')),
      attrs: {
        "id": ("tabList" + (tab.num))
      }
    }, [_c('div', {
      staticClass: "radio-value-label-group",
      attrs: {
        "id": ("radio-value-label-group--" + tabIndex)
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "diagnosis-box"
    }, [_c('div', {
      staticClass: "top-decor-gb-group",
      attrs: {
        "id": ("top-decor-gb-group-" + tabIndex)
      }
    }, [_c('div', {
      staticClass: "top-blue-bg"
    }), _vm._v(" "), _c('div', {
      staticClass: "top-light-blue-bg"
    })]), _vm._v(" "), _c('div', {
      staticClass: "check-answering",
      attrs: {
        "id": ("session-btn-" + tabIndex)
      }
    }, [_c('button', {
      staticClass: "session-btn",
      attrs: {
        "id": ("writebtn" + tabIndex)
      },
      on: {
        "click": function($event) {
          return _vm.doAnswer(tabIndex)
        }
      }
    }, [_vm._v(_vm._s(tab.name) + " 설문 작성하기")])]), _vm._v(" "), _c('ul', {
      class: ("diagnosis-box-ul diagnosis-box-ul--" + tabIndex)
    }, _vm._l((tab.qGroups), function(qGroup, gindex) {
      return _c('li', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!_vm.showFinish),
          expression: "!showFinish"
        }]
      }, [_c('h3', {
        class: ("category-label-title category-label-title--" + gindex)
      }, [_vm._v(_vm._s(tab.name) + " - " + _vm._s(qGroup.label))]), _vm._v(" "), _c('ul', _vm._l((qGroup.questions), function(question, index) {
        return _c('li', {
          staticClass: "self-diagnosis-question"
        }, [_c('div', {
          staticClass: "block-input-group clearfix"
        }, [_c('label', {
          staticClass: "block-input-label"
        }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(question.text))]), _vm._v(" "), _c('div', {
          staticClass: "self-diagnosis-radios"
        }, [_c('label', {
          staticClass: "radio-inline label__radio"
        }, [_c('input', {
          attrs: {
            "type": "radio",
            "name": ("diagosis" + (qGroup.startNo + index)),
            "title": "5 선택"
          },
          domProps: {
            "value": 5
          },
          on: {
            "click": function($event) {
              _vm.answering((qGroup.startNo + index), 5)
            }
          }
        }), _c('span', {
          staticClass: "self-radio-text"
        }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
          staticClass: "radio-inline label__radio"
        }, [_c('input', {
          attrs: {
            "type": "radio",
            "name": ("diagosis" + (qGroup.startNo + index)),
            "title": "4 선택"
          },
          domProps: {
            "value": 4
          },
          on: {
            "click": function($event) {
              _vm.answering((qGroup.startNo + index), 4)
            }
          }
        }), _c('span', {
          staticClass: "self-radio-text"
        }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
          staticClass: "radio-inline label__radio"
        }, [_c('input', {
          attrs: {
            "type": "radio",
            "name": ("diagosis" + (qGroup.startNo + index)),
            "title": "3 선택"
          },
          domProps: {
            "value": 3
          },
          on: {
            "click": function($event) {
              _vm.answering((qGroup.startNo + index), 3)
            }
          }
        }), _c('span', {
          staticClass: "self-radio-text"
        }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
          staticClass: "radio-inline label__radio"
        }, [_c('input', {
          attrs: {
            "type": "radio",
            "name": ("diagosis" + (qGroup.startNo + index)),
            "title": "2 선택"
          },
          domProps: {
            "value": 2
          },
          on: {
            "click": function($event) {
              _vm.answering((qGroup.startNo + index), 2)
            }
          }
        }), _c('span', {
          staticClass: "self-radio-text"
        }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
          staticClass: "radio-inline label__radio"
        }, [_c('input', {
          attrs: {
            "type": "radio",
            "name": ("diagosis" + (qGroup.startNo + index)),
            "title": "1 선택"
          },
          domProps: {
            "value": 1
          },
          on: {
            "click": function($event) {
              _vm.answering((qGroup.startNo + index), 1)
            }
          }
        }), _c('span', {
          staticClass: "self-radio-text"
        }, [_vm._v("1")])])])])])
      }), 0)])
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "diagnosis-submit-btns"
    }, [(tab.num < 6) ? _c('button', {
      staticClass: "diagnosis-submit__btn btn--blue-line",
      on: {
        "click": function($event) {
          return _vm.tabClick(tab.num, tab.num + 1)
        }
      }
    }, [_vm._v("다음 영역 진단하기")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "diagnosis-submit__btn btn--blue-line",
      on: {
        "click": function($event) {
          return _vm.tabClick(tab.num, 7)
        }
      }
    }, [_vm._v("완료 후 결과보기")])])])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFinish),
      expression: "showFinish"
    }],
    staticClass: "tab-pane active"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "diagnosis-box"
  }, [_vm._m(3), _vm._v(" "), _c('ul', {
    staticClass: "diagnosis-box-ul diagnosis-box-ul--7"
  }, [_c('li', [_c('h3', {
    staticClass: "category-label-title category-label-title--0"
  }, [_vm._v("심리 및 정서")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("나는 현재 행복하다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis84",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(84, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis84",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(84, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis84",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(84, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis84",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(84, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis84",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(84, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("나는 퇴직, 노화와 같은 중대한 변화에도 긍정적으로 대처할 수 있다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis85",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(85, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis85",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(85, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis85",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(85, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis85",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(85, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis85",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(85, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("나의 앞날은 여전히 긍정적이고 밝다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis86",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(86, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis86",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(86, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis86",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(86, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis86",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(86, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis86",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(86, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("현재의 생활방식에 만족한다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis87",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(87, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis87",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(87, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis87",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(87, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis87",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(87, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis87",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(87, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("나는 스스로의 감정을 잘 조절할 수 있다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis88",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(88, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis88",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(88, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis88",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(88, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis88",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(88, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis88",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(88, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("대체로 나 자신에 대해 만족한다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis89",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(89, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis89",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(89, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis89",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(89, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis89",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(89, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis89",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(89, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "category-label-title"
  }, [_vm._v("자기이해")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("나는 나 자신을 있는 그대로 받아들일 수 있다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis90",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(90, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis90",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(90, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis90",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(90, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis90",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(90, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis90",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(90, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("나의 장점과 단점에 대해서 알고 있다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis91",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(91, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis91",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(91, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis91",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(91, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis91",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(91, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis91",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(91, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "self-diagnosis-question"
  }, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("내가 가장 원하는 것이 무엇인지 알고 있다.")]), _vm._v(" "), _c('div', {
    staticClass: "self-diagnosis-radios"
  }, [_c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis92",
      "title": "5 선택"
    },
    domProps: {
      "value": 5
    },
    on: {
      "click": function($event) {
        return _vm.answering(92, 5)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("5")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis92",
      "title": "4 선택"
    },
    domProps: {
      "value": 4
    },
    on: {
      "click": function($event) {
        return _vm.answering(92, 4)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("4")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis92",
      "title": "3 선택"
    },
    domProps: {
      "value": 3
    },
    on: {
      "click": function($event) {
        return _vm.answering(92, 3)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("3")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis92",
      "title": "2 선택"
    },
    domProps: {
      "value": 2
    },
    on: {
      "click": function($event) {
        return _vm.answering(92, 2)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("2")])]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "diagosis92",
      "title": "1 선택"
    },
    domProps: {
      "value": 1
    },
    on: {
      "click": function($event) {
        return _vm.answering(92, 1)
      }
    }
  }), _c('span', {
    staticClass: "self-radio-text"
  }, [_vm._v("1")])])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "category-label-title"
  }, [_vm._v("기본")]), _vm._v(" "), _c('ul', [_c('li', {}, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("귀하의 성별은 어떻게 되십니까?")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "M"
    },
    on: {
      "click": function($event) {
        return _vm.answerGender('M')
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "M",
      "type": "radio",
      "name": "gender",
      "value": "M",
      "title": "남자 선택"
    }
  }), _vm._v(" 남자\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "F"
    },
    on: {
      "click": function($event) {
        return _vm.answerGender('F')
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "F",
      "type": "radio",
      "name": "gender",
      "value": "F",
      "title": "여자 선택"
    }
  }), _vm._v(" 여자\n                    ")])])]), _vm._v(" "), _c('li', {}, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label",
    attrs: {
      "for": "age"
    }
  }, [_vm._v("귀하의 연령은 어떻게 되십니까?")]), _vm._v("\n                    만 "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.age),
      expression: "age"
    }],
    staticClass: "input__text input__text--sm",
    attrs: {
      "type": "number",
      "id": "age",
      "placeholder": "",
      "title": "세 입력"
    },
    domProps: {
      "value": (_vm.age)
    },
    on: {
      "change": _vm.answerAge,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.age = $event.target.value
      }
    }
  }), _vm._v(" 세\n                  ")])]), _vm._v(" "), _c('li', {}, [_c('div', {
    staticClass: "block-input-group clearfix"
  }, [_c('label', {
    staticClass: "block-input-label"
  }, [_vm._v("현재 고용상태는 어떻게 되십니까?")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "job_fullTime"
    },
    on: {
      "click": function($event) {
        return _vm.answerJob('정규직')
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "job_fullTime",
      "type": "radio",
      "name": "job",
      "value": "정규직",
      "title": "정규직 선택"
    }
  }), _vm._v(" 정규직\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "job_temporary"
    },
    on: {
      "click": function($event) {
        return _vm.answerJob('임시직')
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "job_temporary",
      "type": "radio",
      "name": "job",
      "value": "임시직",
      "title": "임시직 선택"
    }
  }), _vm._v(" 임시직\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "job_selfEmployment"
    },
    on: {
      "click": function($event) {
        return _vm.answerJob('자영업')
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "job_selfEmployment",
      "type": "radio",
      "name": "job",
      "value": "자영업",
      "title": "자영업 선택"
    }
  }), _vm._v(" 자영업\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "job_leave"
    },
    on: {
      "click": function($event) {
        _vm.answerJob('휴직상태(구직중)')
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "job_leave",
      "type": "radio",
      "name": "job",
      "value": "휴직상태(구직중)",
      "title": "휴직상태(구직중) 선택"
    }
  }), _vm._v(" 휴직상태(구직중)\n                    ")]), _vm._v(" "), _c('label', {
    staticClass: "radio-inline label__radio",
    attrs: {
      "for": "job_retirement"
    },
    on: {
      "click": function($event) {
        return _vm.answerJob('은퇴')
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "job_retirement",
      "type": "radio",
      "name": "job",
      "value": "은퇴",
      "title": "은퇴 선택"
    }
  }), _vm._v(" 은퇴\n                    ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "diagnosis-submit-btns"
  }, [_c('button', {
    staticClass: "diagnosis-submit__btn btn--blue-line",
    on: {
      "click": _vm.submitAnswers
    }
  }, [_vm._v("결과보기")])])])])], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResult),
      expression: "showResult"
    }]
  }, [_c('div', {
    staticClass: "white-box-border"
  }, [_c('h2', {
    staticClass: "white-box-title"
  }, [_vm._v("자가진단 결과")]), _vm._v(" "), _vm._l((_vm.calculResult), function(result, resultIndex) {
    return _c('div', {
      staticClass: "self-diagnosis-result"
    }, [_c('h3', {
      staticClass: "part-title"
    }, [_vm._v(_vm._s(result[1]))]), _vm._v(" "), _c('p', {
      staticClass: "self-diagnosis-result-p"
    }, [_c('span', {
      staticClass: "result-p-accent"
    }, [_vm._v("현재상태")]), _vm._v("의 평균값은 "), _c('span', {
      class: ("result-grade result-grade--" + (_vm.gradeClass(result[4])))
    }, [_vm._v(_vm._s(result[3]))]), _vm._v("점으로 여타 평균과 비교하여"), _c('br', {
      staticClass: "visible-xs"
    }), _vm._v(" "), _c('span', {
      class: ("result-label result-label--" + (_vm.gradeClass(result[4])))
    }, [_vm._v(_vm._s(result[4]) + "  "), _c('i', {
      class: ("fa " + (_vm.arrowClass(result[4])))
    })]), _vm._v(" 나타났습니다.")]), _vm._v(" "), _c('p', {
      staticClass: "self-diagnosis-result-p"
    }, [_c('span', {
      staticClass: "result-p-accent"
    }, [_vm._v("미래준비도")]), _vm._v("의 평균값은 "), _c('span', {
      class: ("result-grade result-grade--" + (_vm.gradeClass(result[7])))
    }, [_vm._v(_vm._s(result[6]))]), _vm._v("점으로 여타 평균과 비교하여"), _c('br', {
      staticClass: "visible-xs"
    }), _vm._v(" "), _c('span', {
      class: ("result-label result-label--" + (_vm.gradeClass(result[7])))
    }, [_vm._v(_vm._s(result[7]) + "  "), _c('i', {
      class: ("fa " + (_vm.arrowClass(result[7])))
    })]), _vm._v(" 나타났습니다.")]), _vm._v(" "), _c('p', {
      staticClass: "self-diagnosis-result-p"
    }, [_c('span', {
      staticClass: "result-p-accent"
    }, [_vm._v("욕구 및 희망")]), _vm._v("의 평균값은 "), _c('span', {
      class: ("result-grade result-grade--" + (_vm.gradeClass(result[10])))
    }, [_vm._v(_vm._s(result[9]))]), _vm._v("점으로 여타 평균과 비교하여"), _c('br', {
      staticClass: "visible-xs"
    }), _vm._v(" "), _c('span', {
      class: ("result-label result-label--" + (_vm.gradeClass(result[10])))
    }, [_vm._v(_vm._s(result[10]) + "  "), _c('i', {
      class: ("fa " + (_vm.arrowClass(result[10])))
    })]), _vm._v(" 나타났습니다.")])])
  }), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-box-border"
  }, [_c('h2', {
    staticClass: "white-box-title"
  }, [_vm._v("자가진단")]), _vm._v(" "), _c('div', {
    staticClass: "notice-wrapper"
  }, [_c('div', {
    staticClass: "post-content"
  }, [_c('p', [_vm._v("본 검사는 삶의 전반적인 영역을 종합적으로 확인해 봄으로써 성공적인 제 2 인생설계에 도움을 드리고자 개발되었습니다.  검사를 통해  보람 있고 균형 잡힌  제 2의 삶을 설계하는 데  필요한 여러 가지 기본적인 정보들을 얻으실 수 있을 것입니다.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("본 검사 문항에는 ‘맞는 답’과 ‘틀린 답’이 없습니다.")])]), _vm._v(" "), _c('p', [_vm._v("정확한 진단과 올바른 처방을 위해 자기 자신의 상태와 생각을 솔직하게 응답해 주시기 바랍니다.  또한 검사 시간에 제한은 없으나 각각의 문항에 대해 너무 오래 생각하지 마시고 떠오르는 대로 바로 바로 답해 주시기  바랍니다.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-value-label"
  }, [_c('div', {
    staticClass: "radio-value-label__text"
  }, [_c('label', {
    staticClass: "radio-text-label radio-text-label--much"
  }, [_vm._v("매우"), _c('br'), _vm._v("그렇다")]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label radio-text-label--middle"
  }, [_vm._v("보통")]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label radio-text-label--not"
  }, [_vm._v("전혀"), _c('br'), _vm._v("아니다")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-value-label__number"
  }, [_c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("5")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("4")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("3")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("2")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("1")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radio-value-label-group",
    attrs: {
      "id": "radio-value-label-group--7"
    }
  }, [_c('div', {
    staticClass: "radio-value-label"
  }, [_c('div', {
    staticClass: "radio-value-label__text"
  }, [_c('label', {
    staticClass: "radio-text-label radio-text-label--much"
  }, [_vm._v("매우"), _c('br'), _vm._v("그렇다")]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label radio-text-label--middle"
  }, [_vm._v("보통")]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label"
  }, [_c('i', {
    staticClass: "fa fa-arrow-right"
  })]), _vm._v(" "), _c('label', {
    staticClass: "radio-text-label radio-text-label--not"
  }, [_vm._v("전혀"), _c('br'), _vm._v("아니다")])]), _vm._v(" "), _c('div', {
    staticClass: "radio-value-label__number"
  }, [_c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("5")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("4")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("3")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("2")]), _vm._v(" "), _c('label', {
    staticClass: "radio-number-label"
  }, [_vm._v("1")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-decor-gb-group",
    attrs: {
      "id": "top-decor-gb-group-7"
    }
  }, [_c('div', {
    staticClass: "top-blue-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-light-blue-bg"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self-diagnosis-result"
  }, [_c('div', {
    staticClass: "info-box--icon"
  }, [_c('div', {
    staticClass: "info-box-icon"
  }, [_vm._v("안내 "), _c('i', {
    staticClass: "fa fa-info-circle"
  })]), _vm._v(" "), _c('p', {
    staticClass: "info-box--icon__p"
  }, [_vm._v("위 생애설계 종합진단은 7대영역의 미래준비도, 욕구 및 희망과 현재상태를 진단한 결과입니다."), _c('br'), _vm._v("\n          이 영역들에 대한 관심을 갖고 미래를 준비하시기를 권합니다. ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "self-diagnosis-result"
  }, [_c('div', {
    staticClass: "post-content"
  }, [_c('p', [_vm._v("위 생애설계 종합진단은 7대영역의 미래준비도, 욕구 및 희망과 현재상태를 진단한 결과 입니다. 이영역들에 대한 관심을 갖고 미래를 준비하시기를 권합니다. ")]), _vm._v(" "), _c('p', [_vm._v("서울시 50플러스에서는 컨설턴트가 생애설계 7대영역에 대한 1:1상담을 무료로 진행하고 있으며,"), _c('br'), _vm._v("\n          50+세대들의 관심이나 선호, 경험, 조건에 따라 선택하도록 ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "blue"
  }, [_c('strong', [_vm._v("인생재설계학부, 커리어모색학부, 일상기술학부")])]), _vm._v(" 세 개의 학부로 구성된 교육프로그램을 학기별로 진행하고 있습니다."), _c('br'), _vm._v("\n          이 기회를 활용하시어 보다 나은 제2의 인생을 설계하시기를 바랍니다.")]), _vm._v(" "), _c('p')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diagnosis-submit-btns"
  }, [_c('a', {
    staticClass: "diagnosis-submit__btn btn--blue",
    attrs: {
      "href": "counsel.do"
    }
  }, [_vm._v("상담 신청하기")]), _vm._v(" "), _c('a', {
    staticClass: "diagnosis-submit__btn btn--blue",
    attrs: {
      "href": "education.do"
    }
  }, [_vm._v("배움 바로가기")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a671526"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/portal/SelfDiagnosis.vue
// module id = 1285
// module chunks = 6